import { globalObject } from '@/global'

import { getStorageUtils } from './storage'

const LocalStorage = getStorageUtils(globalObject.localStorage)
const SessionStorage = getStorageUtils(globalObject.sessionStorage)

export { LocalStorage, SessionStorage }

export type * from './types'
